import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#162242",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
const StyledTableRowLast = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: "#00c389",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));
const StyledTableCellLast = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#162242",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: "#fff",
        fontWeight: 600,
    },
}));
const CommonTable = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(TableContainer, { component: Paper },
            React.createElement(Table, { sx: { minWidth: 700 }, "aria-label": "customized table" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(StyledTableCell, null, "Plan Fees"),
                        React.createElement(StyledTableCell, { align: "left" }, "Here's your first payment"),
                        React.createElement(StyledTableCell, { align: "left" },
                            "Here's your subsequent ",
                            React.createElement("br", null),
                            "monthly payment"))),
                React.createElement(TableBody, null,
                    React.createElement(StyledTableRow, null,
                        React.createElement(StyledTableCell, { component: "th", scope: "row" },
                            "Monthly Payment for ",
                            props.planSelected.planId),
                        React.createElement(StyledTableCell, { component: "th", scope: "row", align: "left" },
                            "$",
                            props.costSelected),
                        React.createElement(StyledTableCell, { align: "left" },
                            "$",
                            props.costSelected)),
                    React.createElement(StyledTableRow, null,
                        React.createElement(StyledTableCell, { component: "th", scope: "row" }, "One Time Enrollment Fee"),
                        React.createElement(StyledTableCell, { component: "th", scope: "row", align: "left" },
                            "$",
                            props.enrollFeeSelected),
                        React.createElement(StyledTableCell, { align: "left" }, "-")),
                    React.createElement(StyledTableRowLast, null,
                        React.createElement(StyledTableCellLast, null, "Family Total"),
                        React.createElement(StyledTableCellLast, { align: "left" },
                            "$",
                            props.costSelected + props.enrollFeeSelected),
                        React.createElement(StyledTableCellLast, { align: "left" },
                            "$",
                            props.costSelected)))))));
};
export default CommonTable;
